import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvService } from '../../../services/env.service';
import { FeeQuoteRequest } from '../types';

@Injectable({
  providedIn: 'root',
})
export class FeeQuoteService {
  private feeQuoteUrl(endpoint: string): string {
    // TODO:TIM Requirements changed, so this can probably be refactored into a single string value, and just interpolate the v2 or v3
    return endpoint === 'v3'
      ? `${this.envService.apiUrl}/v3/transactions/quote`
      : `${this.envService.apiUrl}/v2/transactions/quote`;
  }

  private fxRateUrl(endpoint: string): string {
    // TODO:TIM Requirements changed, so this can probably be refactored into a single string value, and just interpolate the v2 or v3
    return endpoint === 'v3'
      ? `${this.envService.apiUrl}/v3/fx-rate`
      : `${this.envService.apiUrl}/v1/fx-rate`;
  }

  constructor(private http: HttpClient, private envService: EnvService) {}

  getFeeQuote(
    feeQuoteRequest: FeeQuoteRequest,
    endpoint: string
  ): Observable<any> {
    return this.http.post(this.feeQuoteUrl(endpoint), feeQuoteRequest);
  }

  getFxRate(
    feeQuoteRequest: FeeQuoteRequest,
    endpoint: string
  ): Observable<any> {
    return this.http.post(this.fxRateUrl(endpoint), feeQuoteRequest);
  }
}
